import { render, staticRenderFns } from "./FormInfoField.vue?vue&type=template&id=1b3a9a67&scoped=true"
import script from "./FormInfoField.vue?vue&type=script&lang=js"
export * from "./FormInfoField.vue?vue&type=script&lang=js"
import style0 from "./FormInfoField.vue?vue&type=style&index=0&id=1b3a9a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a9a67",
  null
  
)

export default component.exports